module.exports = __webpack_public_path__ + "img/crab.b5497a0e.png";